<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Vendas</h1>
    <span *ngIf="carregado" class="badge bg-secondary">Total: {{ quantidadeRegistros }}</span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    <div class="col-md-2">
      <label class="form-label">Data Inicial <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataInicialInvalida"
             [(ngModel)]="dataInicial" />
      <div class="invalid-feedback" *ngIf="dataInicialInvalida">
        Informe a data inicial.
      </div>
    </div>
    <div class="col-md-2">
      <label class="form-label">Data Final <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataFinalInvalida"
             [(ngModel)]="dataFinal" />
      <div class="invalid-feedback" *ngIf="dataFinalInvalida">
        Informe a data final.
      </div>
    </div>
    <div class="col-md-2">
      <label class="form-label">Status da Venda</label>
      <select class="form-select" [(ngModel)]="statusVenda">
        <option value="">Todos</option>
        <option *ngFor="let p of statusOptions" [value]="p.descricao">{{ p.descricao }}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label class="form-label">Forma de Pagamento</label>
      <select class="form-select" [(ngModel)]="formaPagamento">
        <option value="">Todas</option>
        <option *ngFor="let p of formasPagamento" [value]="p.descricao">{{ p.descricao }}</option>
      </select>
    </div>
    <div class="col-md-1">
      <label class="form-label">ID Vendedor</label>
      <input type="number" min="1" class="form-control" [(ngModel)]="idVendedor" placeholder="Todos" />
    </div>
    <div class="col-md-3 d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!dataInicial || !dataFinal)">
    Informe a data inicial e a data final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado">

    <div class="d-flex justify-content-end mb-2 no-print">
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <!-- Cabeçalho visível apenas na impressão -->
    <div class="print-header print-only">
      <div class="print-header-title">Relatório de Vendas</div>
      <div class="print-header-meta">
        <span>
          Período: {{ dataInicial | date:'dd/MM/yyyy' }} a {{ dataFinal | date:'dd/MM/yyyy' }}
        </span>
        <span class="print-header-sep" *ngIf="statusVenda"> | Status: {{ statusVenda }}</span>
        <span class="print-header-sep" *ngIf="formaPagamento"> | Forma Pgto: {{ formaPagamento }}</span>
        <span class="print-header-sep" *ngIf="idVendedor"> | Vendedor: {{ idVendedor }}</span>
        <span class="print-header-sep"> | Total: {{ quantidadeRegistros }} registro(s)</span>
        <span class="print-header-sep"> | Gerado em: {{ dataGeracao }}</span>
      </div>
      <div class="print-header-divider"></div>
    </div>

    <div *ngIf="vendas.length === 0" class="text-center text-muted py-4">
      Nenhuma venda encontrada para os filtros selecionados.
    </div>

    <div class="table-responsive" *ngIf="vendas.length > 0">
      <table class="table table-striped table-hover print-table">
        <thead class="table-dark">
          <tr>
            <th scope="col">ID Venda</th>
            <th scope="col">ID Orçamento</th>
            <th scope="col">Cliente</th>
            <th scope="col">Vendedor</th>
            <th scope="col" class="text-center">Data Venda</th>
            <th scope="col" class="text-center">Status</th>
            <th scope="col" class="text-center">Forma Pagamento</th>
            <th scope="col" class="text-end">Total Venda</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let venda of vendas">
            <td>{{ venda.idVenda }}</td>
            <td>{{ venda.idOrcamento }}</td>
            <td>{{ venda.nomeCliente }}</td>
            <td>{{ venda.nomeVendedor }}</td>
            <td class="text-center">{{ venda.dataVenda | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">
              <span class="status-badge"
                [class.status-concluido]="venda.statusVenda === 'CONCLUIDO' || venda.statusVenda === 'PAGO'"
                [class.status-parcelado]="venda.statusVenda === 'PARCELADO'"
                [class.status-pendente]="venda.statusVenda === 'PENDENTE'">
                {{ venda.statusVenda }}
              </span>
            </td>
            <td class="text-center">{{ venda.formaPagamento }}</td>
            <td class="text-end fw-bold">{{ venda.totalVenda | currency:'BRL' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="print-totals">
            <td colspan="7" class="text-end fw-bold">Total do período:</td>
            <td class="text-end fw-bold">{{ valorTotalPeriodo | currency:'BRL' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
